import { Button, Label, useValidationResultDialog } from '@nest/uikit-react';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useTerminalClient } from '../client-rpc-router';
import { StorageLocationScanInput } from '../components/StorageLocationScanInput';
import { TerminalScreen } from '../components/TerminalScreen';
import { useNumberParam } from '../helpers';

export default function OutboundDeliveryOrderProcessPackPage() {
	const id = useNumberParam('id');
	const client = useTerminalClient();
	const [sourceLocation, setSourceLocation] = useState<any | null>(null);

	const confirmMutation = useMutation({
		mutationFn: () => client.outboundDeliveryOrders.confirmOutboundDeliveryOrderShipmentPackMutation.execute({ id: id!, sourceStorageLocationId: sourceLocation?.id }),
		onSuccess: () => {}
	});

	useValidationResultDialog([confirmMutation.error]);

	return (
		<TerminalScreen showBackButton topBar={<div>Balit výdej #{id}</div>}>
			<div className="p-4 space-y-4">
				<div>
					<Label className="mb-1 block">Zdrojová lokace</Label>
					<StorageLocationScanInput placeholder="Naskenujte lokaci..." value={sourceLocation} onChange={setSourceLocation} autoFocus />
				</div>
				<Button className="w-full" onClick={() => confirmMutation.mutate()} disabled={!sourceLocation || confirmMutation.isPending}>
					Potvrdit balení
				</Button>
			</div>
		</TerminalScreen>
	);
}
